import { render } from "./CongratsIcon.vue?vue&type=template&id=1df8db9c"
import script from "./CongratsIcon.vue?vue&type=script&lang=js"
export * from "./CongratsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__